/**
 * web-office-sdk
 */
import WebOfficeSDK from "~/assets/js/web-office-sdk-solution-v2.0.7/web-office-sdk-solution-v2.0.7.es.js";

export default defineNuxtPlugin({
  name: "web-office-sdk-plugin",
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.provide("WebOfficeSDK", WebOfficeSDK);
  },
});

declare module "nuxt/app" {
  interface NuxtApp {
    $WebOfficeSDK: any;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $WebOfficeSDK: any;
  }
}
